const MenuChrome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      data-testid="chrome-browser-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.494C9 4.319 8.328 4.988 7.5 4.988C6.672 4.988 6 4.32 6 3.494C6 2.668 6.672 2 7.5 2C8.328 2 9 2.67 9 3.494ZM9 8.5C9 9.325 8.328 9.994 7.5 9.994C6.672 9.994 6 9.325 6 8.5C6 7.675 6.672 7.006 7.5 7.006C8.328 7.006 9 7.675 9 8.5ZM9 13.506C9 14.331 8.328 15 7.5 15C6.672 15 6 14.33 6 13.506C6 12.681 6.672 12.012 7.5 12.012C8.328 12.012 9 12.681 9 13.506Z"
        fill="white"
      />
    </svg>
  );
};

export default MenuChrome;
